// extracted by mini-css-extract-plugin
export default {"titles":"TitleListWrapper_titles__l7l-u"};